module.exports = __webpack_public_path__ + "img/use-bg.1c8c7cbb.png";